import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

// Jds
import {
  ActionButton,
  Button,
  Container,
  Icon,
  InputFieldV2,
  InputRadio,
  Notifications,
  ProgressBar,
  SearchBox,
  Spinner,
  Text,
  Tooltip,
} from "@jds/core";

// Mui
import { Box, ImageList } from "@mui/material";
import "./FacesPage.css";

// Local
import EventBanner from "../components/UI/EventBanner";
import EventDescriptionCard from "../components/UI/Cards/EventDescriptionCard";
import Face from "../components/UI/Face";
import { useNavigate, useParams } from "react-router-dom";
import useApiHttp from "../hooks/use-http";
import EmptyState from "../components/NoData/EmptyState";
import Loader from "../components/UI/Loader/Loader";
import GridContainer from "../components/Layout/GridContainer";
import PageLoader from "../components/UI/Loader/PageLoader";
import { imgValidationCheck, validateFileSignature } from "../util/helper";
import NameOfFaceForm from "../components/UI/Form/NameOfFaceForm";
import JdsModal from "../components/UI/JdsModal";
import FaceListModal from "../components/UI/FaceListModal";
import { FilterList } from "@mui/icons-material";
import ActiveAlertContainer from "../components/UI/ActiveAlertContainer/ActiveAlertContainer";
import { FileUploadContext } from "../components/Layout/FileUploadLayout";
import ReindexAlert from "../components/UI/ReindexAlert/ReindexAlert";
import { useDispatch, useSelector } from "react-redux";
import MuiPopover from "../components/UI/MuiPopover";
import ClusterStatus from "../components/UI/ClusterStatus/ClusterStatus";
import { NewFileUploadContext } from "../components/Layout/NewFileUploadLayout/NewFileUploadLayout";

const SortBtn = (props) => (
  <Button
    iconLeft={"IcSort"}
    label={props?.label || "Sort"}
    kind="tertiary"
    {...props}
  />
);
const SortComponent = ({
  sortValue,
  sortOrder,
  setSortValue = () => {},
  setSortOrder = () => {},
  applySortAction = () => {},
  removeSortAction = () => {},
  close = () => {},
  sortValuePar = "",
  sortOrderPar = "",
}) => {
  return (
    <div
      style={{
        padding: "10px",
        width: "215px",
      }}
    >
      <div className={"sort-block"}>
        <Text text="Sort by" appearance="" />
        <div className={"sort-ele"}>
          <InputRadio
            size="small"
            value="username"
            onClick={(e) => {
              setSortValue(e.target.value);
            }}
            checked={sortValue == "username" ? true : false}
          />
          <span
            onClick={(e) => {
              setSortValue("username");
            }}
          >
            <Text text="Name" color="primary_grey_80" />
          </span>
        </div>{" "}
        <div className={"sort-ele"}>
          <InputRadio
            size="small"
            value="imageCount"
            onClick={(e) => {
              setSortValue(e.target.value);
            }}
            checked={sortValue == "imageCount" ? true : false}
          />
          <span
            onClick={(e) => {
              setSortValue("imageCount");
            }}
          >
            <Text text="Count" color="primary_grey_80" />
          </span>
        </div>
        <Text text="Sort order" appearance="" />
        <div className={"sort-ele"}>
          <InputRadio
            size="small"
            value="asc"
            onClick={(e) => {
              setSortOrder(e.target.value);
            }}
            checked={sortOrder == "asc" ? true : false}
          />
          <span
            onClick={(e) => {
              setSortOrder("asc");
            }}
          >
            <Text
              text={sortValue == "username" ? "A to Z" : "Low on top"}
              color="primary_grey_80"
            />
          </span>
        </div>{" "}
        <div className={"sort-ele"}>
          <InputRadio
            size="small"
            value="desc"
            onClick={(e) => {
              setSortOrder(e.target.value);
            }}
            checked={sortOrder == "desc" ? true : false}
          />
          <span
            onClick={(e) => {
              setSortOrder("desc");
            }}
          >
            <Text
              text={sortValue == "username" ? "Z to A" : "High on top"}
              color="primary_grey_80"
            />
          </span>
        </div>{" "}
      </div>
      <div style={{ marginTop: "16px" }}>
        <Button
          fullWidth
          kind="secondary"
          size="small"
          label="Apply Sort"
          onClick={() => {
            applySortAction();
            close();
          }}
          disabled={!sortValue || !sortOrder}
        />
      </div>
      <div style={{ marginTop: "16px" }}>
        <Button
          fullWidth
          size="small"
          label="Clear Sort"
          onClick={() => {
            setSortOrder("");
            setSortValue("");
            removeSortAction();
            close();
          }}
          disabled={!(sortValuePar && sortOrderPar)}
        />
      </div>
    </div>
  );
};
export default function Faces() {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const { handleReindex, reindexStaus } = useContext(FileUploadContext);
  const { tasks = [] } = useContext(NewFileUploadContext);
  const { reindexFace } = useSelector((state) => state.apiTrigger);

  const { sendRequest: searchByNameRequest, isLoading: issearchByNameLoading } =
    useApiHttp();
  const { sendRequest: getPhotoList, isLoading: isGetPhotoListLoading } =
    useApiHttp();
  const { sendRequest: clusterStatusReq, isLoading: isclusterStatusLoading } =
    useApiHttp();
  const { sendRequest: searchImgRequest, isLoading: searchImgLoading } =
    useApiHttp();
  const { sendRequest: resquestIdSearch, isLoading: resquestIdSearchLoading } =
    useApiHttp();
  const [planActive, setPlanActive] = useState(true);
  const [planActiveMsg, setPlanActiveMsg] = useState("");
  const [isPoolLoading, setIsPoolLoading] = useState(false);
  const [facesList, setFacesList] = useState([]);
  const [clusterStatus, setClusterStatus] = useState(null);
  const [requestId, setRequestId] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sortValue, setSortValue] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [sortValuePar, setSortValuePar] = useState("");
  const [sortOrderPar, setSortOrderPar] = useState("");
  const [clearPoolRequestInterval, setClearPoolRequestInterval] =
    useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [totalFacesCount, setTotalFacesCount] = useState(0);
  const searchImgInput = useRef(null);
  const [isEditModalClose, setEditModalClose] = useState(true);
  const [isSharePhotosModalClose, setSharePhotosModalClose] = useState(true);

  const [shareLink, setShareLink] = useState(null);
  const [isReindeModalClose, setReindeModalClose] = useState(true);
  const [faceName, setFaceName] = useState("");
  const [faceData, setFaceData] = useState({});
  const [modalUsername, setModalUsername] = useState();
  const [faceCount, setFaceCount] = useState(0);
  const [isFaceLisModalClosed, setIsFaceModalClose] = useState(true);

  const [clusterModalCls, setClusterModalCls] = useState(true);
  const [refetchAftClu, setRefetchAftClu] = useState(false);

  const clusterInProgress =
    clusterStatus?.status !== "COMPLETED" || clusterStatus?.hasNewUploads;
  const clusteringCompleted =
    clusterStatus?.stage === "CROP_FACES" &&
    clusterStatus?.status === "COMPLETED" &&
    !clusterStatus?.hasNewUploads;

  const getFaceImages = (page) => {
    getPhotoList(
      {
        url: `face/clusters?eventId=${eventId}&size=200&page=${page}${
          sortValuePar && sortOrderPar
            ? `&sort=${sortValuePar},${sortOrderPar}`
            : ""
        }`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        if (page === 0) {
          setFacesList(data?.data);
          setTotalFacesCount(data?.count);
          setLastPage(data?.lastPage);
        } else {
          if (data?.data) {
            setFacesList((pre) => [...pre, ...data?.data]);
            setTotalFacesCount(data?.count);
            setLastPage(data?.lastPage);
          }
        }
      },
      (err, data) => {
        if (data?.statusCode == 402) {
          setPlanActive(false);
          setPlanActiveMsg(data?.message);
        } else {
          Notifications.toast.error({
            id: "face-page",
            title: data?.message,
          });
        }
      }
    );
  };

  const searchFaceByName = (name) => {
    searchByNameRequest(
      {
        url: `face/search/name?name=${name}&eventId=${eventId}&size=50&page=${page}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        Notifications.toast.success({ id: "search_face", title: data.message });
        if (page === 0) {
          setFacesList(data?.data);
          setTotalFacesCount(data?.count);
          setLastPage(data?.lastPage);
        } else {
          if (data?.data) {
            setFacesList((pre) => [...pre, ...data?.data]);
            setTotalFacesCount(data?.count);
            setLastPage(data?.lastPage);
          }
        }
      },
      (err, data) => {
        Notifications.toast.error({ id: "search_face", title: data.message });
        setFacesList([]);
        setTotalFacesCount(0);
      }
    );
  };

  const searchFaceByImage = (file) => {
    const formData = new FormData();
    formData.append("uploadFile", file);
    formData.append("eventId", eventId);
    searchImgRequest(
      {
        url: `face/search-image`,
        method: "POST",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        setRequestId(data?.data?.requestId);
        setIsPoolLoading(true);
      },
      (err, data) => {
        Notifications.toast.error({ id: "search_face", title: data.message });
      }
    );
  };

  const searchByRequestId = (id) => {
    resquestIdSearch(
      {
        url: `face/pool-search-result?requestId=${id}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        if (data?.data) {
          setClearPoolRequestInterval(true);
          setIsPoolLoading(false);
          setFacesList(data.data);
          setLastPage(data?.lastPage);
          setTotalFacesCount(data?.count);
        }
        // setFacesList(data.data);
      }
    );
  };
  const applySortAction = () => {
    if (sortValue !== sortValuePar || sortOrder !== sortOrderPar) {
      setFacesList([]);
      setPage(0);
      setSortValuePar(sortValue);
      setSortOrderPar(sortOrder);
    }
  };
  const removeSortAction = () => {
    setFacesList([]);
    setPage(0);
    setSortValuePar("");
    setSortOrderPar("");
  };
  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (issearchByNameLoading || isGetPhotoListLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [issearchByNameLoading, isGetPhotoListLoading, lastPage]
  );

  // useEffect(() => {
  //   let poolRequestInterval;
  //   if (requestId) {
  //     poolRequestInterval = setInterval(() => {
  //       searchByRequestId(requestId);
  //     }, 5000);
  //     // if (clearPoolRequestInterval) {
  //
  //     //   return clearInterval(poolRequestInterval);
  //     // }
  //   }
  //   return () => {
  //     if (poolRequestInterval) {
  //       clearInterval(poolRequestInterval);
  //     }
  //   };
  // }, [requestId, clearPoolRequestInterval]);

  // useEffect(() => {
  //   let poolRequestInterval;
  //   if (requestId) {
  //     poolRequestInterval = setInterval(() => {
  //       searchByRequestId(requestId);
  //     }, 5000);
  //   }
  //   return () => {
  //     if (poolRequestInterval && clearPoolRequestInterval) {
  //       clearInterval(poolRequestInterval);
  //       setClearPoolRequestInterval(false);
  //     }
  //   };
  // }, [requestId, clearPoolRequestInterval]);

  useEffect(() => {
    if (requestId) {
      const id = setInterval(() => {
        searchByRequestId(requestId);
      }, 5000);
      setIntervalId(id);

      // Clear the interval on component unmount
      return () => clearInterval(id);
    }
  }, [requestId]);

  useEffect(() => {
    if (clearPoolRequestInterval && intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
      setClearPoolRequestInterval(false);
    }
  }, [clearPoolRequestInterval, intervalId]);

  useEffect(() => {
    if (reindexFace[eventId]) {
      if (page == 0) {
        getFaceImages(0);
      } else {
        setPage(0);
      }
    }
  }, [reindexFace]);

  useEffect(() => {
    if (searchValue.length) {
      searchFaceByName(searchValue);
    }
    if (searchValue.length < 1) {
      getFaceImages(page);
    }
  }, [page, sortValuePar, sortOrderPar]);

  useEffect(() => {
    if (refetchAftClu) {
      if (page == 0) {
        getFaceImages(0);
      } else {
        setPage(0);
      }
    }
  }, [refetchAftClu]);
  useEffect(() => {
    clusterStatusReq(
      {
        url: `face/cluster/status/${eventId}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setClusterStatus(data?.data);
      },
      (err) => {
        setClusterStatus(null);
      }
    );
  }, []);

  if (!planActive) {
    return <ActiveAlertContainer message={planActiveMsg} />;
  }
  // reindexStaus?.[eventId] == "PENDING"
  if (reindexStaus?.[eventId] == "PENDING") {
    return (
      <div>
        <div>
          <Text text={`Faces `} appearance="heading-xs" />
        </div>
        <div
          style={{
            height: "calc(100vh - 300px)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              maxWidth: "584px",
              width: "100%",
              marginInline: "auto",
            }}
          >
            <ReindexAlert />
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <Container
        fullWidth
        horizontalAlign="space-between"
        className="faces-heading"
        style={{
          marginBottom: "40px",
          paddingTop: "32px",
          marginTop: "-32px",
          position: "sticky",
          top: "72px",
          backgroundColor: "white",
          paddingBottom: "16px",
          zIndex: 30,
          flexWrap: "wrap",
        }}
      >
        <Container direction="row" verticalAlign="end" gap={8}>
          <Text text={`Faces `} appearance="heading-xs" />
          <Text
            text={`${totalFacesCount ? `- ${totalFacesCount}` : ""}`}
            appearance="body-m"
            color="primary-grey-80"
          />
        </Container>
        <Container verticalAlign="center" gap={16}>
          {" "}
          {/* {totalFacesCount > 0 && (
            <Button
              kind="secondary"
              iconLeft={"IcScanFace"}
              label="Face Reindex"
              size="small"
              onClick={() => {
                setReindeModalClose(false);
              }}
            />
          )} */}
          <div
            style={{
              display: "flex",
              gap: "8px",
              direction: "row",
              justifyContent: "right",
              alignItems: "center",
            }}
          >
            <input
              ref={searchImgInput}
              type="file"
              accept=".png, .jpg, .jpeg"
              onChange={(e) => {
                const file = e.target.files[0];
                if (imgValidationCheck(e)) {
                  validateFileSignature(file, {
                    jpeg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffdb"], // JPEG signatures can vary
                    png: ["89504e47"],
                  })
                    .then((isValid) => {
                      if (isValid) {
                        searchFaceByImage(e.target.files[0]);
                      } else {
                        Notifications.toast.error({
                          id: "search-face-img",
                          title:
                            "Please upload a valid image file (JPG, JPEG and PNG).",
                        });
                      }
                    })
                    .catch((error) => {
                      Notifications.toast.error({
                        id: "search-face-img",
                        title:
                          "Please upload a valid image file (JPG, JPEG and PNG).",
                      });
                    });
                } else {
                  Notifications.toast.error({
                    id: "search-face-img",
                    title:
                      "Please upload a valid image file (JPG, JPEG and PNG).",
                  });
                }
              }}
            />
            {clusterStatus?.status && facesList.length > 0 && (
              <div
                className={`btn--blinking btn--blinking-${
                  clusterInProgress
                    ? "negative"
                    : clusteringCompleted
                    ? "positive"
                    : ""
                }`}
              >
                <ActionButton
                  kind="secondary"
                  label="Faces Status"
                  icon="IcScanFace"
                  size="medium"
                  appearance={
                    clusterInProgress
                      ? "negative"
                      : clusteringCompleted
                      ? "positive"
                      : ""
                  }
                  onClick={() => {
                    setClusterModalCls(false);
                  }}
                />
              </div>
            )}
            <MuiPopover
              trigger={{
                component: SortBtn,
              }}
            >
              <SortComponent
                sortValue={sortValue}
                sortOrder={sortOrder}
                sortValuePar={sortValuePar}
                sortOrderPar={sortOrderPar}
                setSortValue={setSortValue}
                setSortOrder={setSortOrder}
                applySortAction={applySortAction}
                removeSortAction={removeSortAction}
              />
            </MuiPopover>
            <Tooltip label="Search by image" position="bottom">
              <div>
                <SearchBox
                  label="Search Faces"
                  prefix="IcSearch"
                  value={searchValue}
                  suffix={
                    !requestId && searchValue.length === 0
                      ? "IcPhoto"
                      : "IcError"
                  }
                  onSuffixClick={() => {
                    if (requestId || searchValue.length !== 0) {
                      if (page !== 0) {
                        setPage(0);
                      } else {
                        getFaceImages(0);
                      }
                      setSearchValue("");
                      setRequestId("");
                    } else {
                      if (searchValue.length === 0) {
                        if (searchImgInput.current) {
                          searchImgInput.current.value = null; //reset file
                          searchImgInput.current.click();
                        }
                      }
                    }
                  }}
                  onChange={(e) => {
                    const searchValue = e.target.value;
                    setSearchValue(searchValue);
                    if (searchValue.length) {
                      if (page !== 0) {
                        setPage(0);
                      } else {
                        searchFaceByName(searchValue);
                      }
                    }
                    if (searchValue.length < 1) {
                      if (page !== 0) {
                        setPage(0);
                      } else {
                        getFaceImages(0);
                      }
                    }
                  }}
                />
              </div>
            </Tooltip>
          </div>{" "}
        </Container>
      </Container>
      <Container fullWidth>
        {facesList?.length && (
          <Container fullWidth direction="column">
            {/* <GridContainer minWidth="184px" maxWidth="184px"> */}
            <ImageList
              cols={5}
              rowHeight={240}
              sx={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {facesList.map((item, i) => {
                return (
                  <div ref={facesList.length === i + 1 ? lastElementRef : null}>
                    <Face
                      key={i}
                      data={item}
                      isSuccess={() => {
                        // window.scrollTo(0, 0);
                        // if (page !== 0) {
                        //   setPage(0);
                        // } else {
                        //   if (searchValue) {
                        //     searchFaceByName(searchValue);
                        //   } else {
                        //     getFaceImages(0);
                        //   }
                        // }
                      }}
                      setFaceData={(val) => {
                        setFaceData(val);
                      }}
                      setEditModalClose={(val) => {
                        setEditModalClose(val);
                      }}
                      isFaceLisModalClosed={isFaceLisModalClosed}
                      // setIsFaceModalClose={setIsFaceModalClose}
                      onClickNavigate={() => {
                        navigate(
                          `/home/events/faces/${eventId}/face-list/${item?.clusterId}`,
                          {
                            state: {
                              username: item?.username,
                              mediaUrl: item?.mediaUrl,
                            },
                          }
                        );
                      }}
                    />
                  </div>
                );
              })}
            </ImageList>
            {/* </GridContainer> */}
            {((issearchByNameLoading && page !== 0) ||
              (isGetPhotoListLoading && page !== 0)) && <Loader size="small" />}
          </Container>
        )}
      </Container>
      {facesList?.length == 0 &&
        searchValue.length == 0 &&
        !requestId &&
        !isGetPhotoListLoading && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <EmptyState title="No faces found!" subtitle="" action={false} />

            {clusterStatus?.status && clusterStatus?.status !== "COMPLETED" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    fontFamily: "var(--font-medium)",
                  }}
                >
                  <Icon ic={"IcScanFace"} />
                  <Text
                    appearance="body-m"
                    text={"We're processing your photos!"}
                    as="span"
                    color="primary_grey_80"
                  />
                </div>
                <Button
                  label="Show details"
                  onClick={() => {
                    console.log("clicked");
                    setClusterModalCls(false);
                  }}
                />
              </>
            ) : (
              <Text
                appearance="body-m"
                text={"Start uploading to see the detected faces."}
                as="span"
                color="primary_grey_80"
              />
            )}
          </div>
        )}
      {facesList?.length == 0 &&
        (searchValue.length > 0 || requestId) &&
        !issearchByNameLoading && (
          <EmptyState
            title="No faces found!"
            subtitle="Try removing or adjusting your filters to see more results."
            action={false}
          />
        )}
      {(issearchByNameLoading || isGetPhotoListLoading) && page == 0 && (
        <Container
          fullWidth
          horizontalAlign="center"
          verticalAlign="center"
          style={{ minHeight: "220px" }}
        >
          <Spinner kind="primary" label="Loading..." size="large" />
        </Container>
      )}
      {(searchImgLoading || resquestIdSearchLoading || isPoolLoading) && (
        <PageLoader
          open={
            issearchByNameLoading ||
            searchImgLoading ||
            resquestIdSearchLoading ||
            isPoolLoading ||
            isGetPhotoListLoading
          }
          label={isPoolLoading && "Please wait for a while..."}
          labelprops={{ color: "white" }}
        />
      )}
      {/* NameOfFace form Modal */}
      <JdsModal
        header="Name of the Face"
        size="m"
        close={isEditModalClose}
        onClose={() => {
          setEditModalClose(true);
        }}
      >
        {!isEditModalClose && (
          <NameOfFaceForm
            data={faceData}
            isSuccess={(bool, name, id) => {
              setFaceName(name);
              setFacesList((pre) => {
                const updateList = pre.map((item) => {
                  if (item.clusterId == id) {
                    return { ...item, username: name };
                  } else {
                    return item;
                  }
                });
                return updateList;
              });
            }}
          />
        )}
      </JdsModal>
      {/* Share form Modal */}
      <JdsModal
        header="Share Link"
        // kind="informational"
        size="m"
        close={isSharePhotosModalClose}
        onClose={() => {
          setSharePhotosModalClose(true);
        }}
      >
        {!isSharePhotosModalClose && (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            <Box
              sx={{
                "& .j-JDSInputFieldV2-input-container": { height: "unset" },
                "& .j-JDSIcon-container": { padding: "24px", borderRadius: 0 },
                "& .j-JDSIcon-container:nth-child(1)": {
                  paddingLeft: "12px",
                  borderRight: "1px solid var(--color-primary-grey-60)",
                },
                "& .j-JDSIcon-container:nth-child(3)": {
                  paddingRight: "12px",
                  borderLeft: "1px solid var(--color-primary-grey-60)",
                },
                "& .j-JDSIcon-container:nth-child(1) .icon-atom.j-JDSIcon-icon":
                  {
                    color: "var(--color-primary-60)",
                  },
                "& .j-JDSIcon-container:nth-child(3) .icon-atom.j-JDSIcon-icon":
                  {
                    // color: "var(--color-feedback-error-50)",
                  },
              }}
            >
              <InputFieldV2
                prefix={<Icon ic={"IcLink"} />}
                value={shareLink}
                onChange={(e) => {
                  e.preventDefault();
                }}
              />
            </Box>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigator.clipboard
                    .writeText(shareLink)
                    .then(() => {
                      Notifications.toast.success({
                        id: "copy-link",
                        title: "Link copied to clipboard",
                      });
                    })
                    .catch((err) => {});
                }}
              >
                <Icon ic={"IcCopy"} size="xtra-xtra-large" />
                <Text text="Copy Link" />
              </span>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const message =
                    "Check out the link, it’s got some awesome photos for you!";
                  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
                    message
                  )}%20${encodeURIComponent(shareLink)}`;
                  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
                }}
              >
                <Icon ic={"IcWhatsapp"} size="xtra-xtra-large" />
                <Text text="WhatsApp" />
              </span>
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const body = shareLink;
                  const mailToLink = `mailto:?body=${encodeURIComponent(body)}`;
                  window.open(mailToLink, "_blank", "noopener,noreferrer");
                }}
              >
                <Icon ic={"IcMail"} size="xtra-xtra-large" />
                <Text text="Email" />
              </span>
            </div>
          </div>
        )}
      </JdsModal>

      <JdsModal
        header={`${modalUsername || "Unnamed"} - ${faceCount}`}
        kind="custom"
        close={isFaceLisModalClosed}
        onClose={() => {
          setIsFaceModalClose(true);
          // window.location.reload();
        }}
      >
        {!isFaceLisModalClosed && (
          <FaceListModal
            modalUsername={modalUsername}
            faceCount={faceCount}
            setModalUsername={setModalUsername}
            setFaceCount={setFaceCount}
            isFaceLisModalClosed={isFaceLisModalClosed}
            setIsFaceModalClose={setIsFaceModalClose}
            data={faceData}
            setEditModalClose={(id, name, url) => {
              setEditModalClose(false);
              const updateData = facesList.find(
                (item, val) => item.clusterId == id
              );
              if (updateData) {
                setFaceData(updateData);
              } else {
                setFaceData({
                  clusterId: id,
                  username: name,
                  mediaUrl: url || "",
                });
              }
            }}
            setSharePhotosModalClose={(id, name, url) => {
              setSharePhotosModalClose(false);
              setShareLink(
                `${process.env.REACT_APP_API_DOMAIN}easy-share/?event_id=${eventId}&cluster_id=${id}`
              );
              const updateData = facesList.find(
                (item, val) => item.clusterId == id
              );
              if (updateData) {
                setFaceData(updateData);
              } else {
                setFaceData({
                  clusterId: id,
                  username: name,
                  mediaUrl: url || "",
                });
              }
            }}
          />
        )}
      </JdsModal>
      <JdsModal
        header=""
        kind="informational"
        close={isReindeModalClose}
        onClose={() => {
          setReindeModalClose(true);
        }}
        size="m"
      >
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            <Text appearance="body-l-bold" text="Face Reindex" />
            <Text
              appearance="body-m"
              text={
                "Please note: This process will organize your photos. However, sharing and uploading photos from events will be unavailable during this time."
              }
              color="primary_grey_80"
            />
            <div
              style={{
                alignSelf: "end",
                display: "flex",
                flexDirection: "row",
                gap: "12px",
              }}
            >
              <Button
                kind="secondary"
                label="Dismiss"
                onClick={() => {
                  setReindeModalClose(true);
                }}
              />
              <Button
                kind="primary"
                label="Proceed"
                onClick={() => {
                  handleReindex({ eventId });
                  setReindeModalClose(true);
                }}
              />
            </div>
          </div>
        </>
      </JdsModal>

      {/* Cluster status alert */}
      {/* {clusterStatus?.status &&
        clusterStatus?.status !== "COMPLETED" &&
        clusterStatus?.status !== "FAILED" &&
        facesList?.length > 0 && (
          <div
            className="cluster-info-container"
            onClick={() => {
              setClusterModalCls(false);
            }}
            style={{
              zIndex: clusterModalCls ? 111 : 60,
              right: tasks?.length > 0 ? "478px" : "20px",
            }}
          >
            <p
              style={{
                display: "flex",
                gap: "6px",
                fontFamily: "var(--font-medium)",
              }}
            >
              {" "}
              <Icon ic={"IcScanFace"} /> We're processing your photos! Tap for
              details.
            </p>
          </div>
        )} */}
      {/* Cluster status alert modal */}

      <JdsModal
        size="m"
        // header="Your Photo Is Being Prepared."
        kind="custom"
        close={clusterModalCls}
        onClose={() => {
          setClusterModalCls(true);
        }}
        headerProps={{ divider: "false" }}
      >
        {!clusterModalCls && (
          <ClusterStatus
            clusterStatusProp={clusterStatus}
            setClusterStatusProp={setClusterStatus}
            setRefetchAftClu={setRefetchAftClu}
            clusteringAttempt={clusterStatus?.clusteringAttempt || 0}
          />
        )}
      </JdsModal>
    </>
  );
}
